// @flow

import ReduceStore from 'PMT/flux/ReduceStore'

import Events from 'constants/Events'
import ActionTypes from 'constants/ActionTypes'

import ApiError from 'PMT/entities/ApiError'

class OrderStatisticsStore extends ReduceStore {

  getInitialState() {
    return {
      data: null,
      apiError: null,
      isFetching: false,
    }
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      data: {},
      isFetching: false,
    }
  }

  getState() {
    return this._state
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      case ActionTypes.GET_ORDER_STATISTICS:
        nextState.data = null
        nextState.isFetching = true
        nextState.apiError = null
      return nextState

      case ActionTypes.GET_ORDER_STATISTICS_SUCCESS:
        nextState.data = action.data
        nextState.isFetching = false
        nextState.apiError = null
        return nextState

      case ActionTypes.GET_ORDER_STATISTICS_FAILURE:
        nextState.data = null
        nextState.isFetching = false
        nextState.apiError = action.apiError
        return nextState

      default:
        return nextState
    }
  }
}

export default new OrderStatisticsStore()
